/* This file is autogenerated, see readme.md for instructions */
import ArrowCollapseSvgIcon from '@bloomreach/banana-theme/icons/arrow-collapse.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ArrowCollapseIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ArrowCollapseSvgIcon />
    </Icon>
  );
});

ArrowCollapseIcon.displayName = 'ArrowCollapseIcon';

export default ArrowCollapseIcon;
